import React, { useEffect } from 'react';
import Chart from 'react-apexcharts';
import dayjs from 'dayjs';

import { ChartWrapper } from '../../../components/Charts/ChartWrapper';
import { useAppSelector } from '../../../../../store';
import { useLazyGetMessagesQuery } from '../service/messages.api';
import { buildWeeklySeries, getOptions } from '../utils/chartOptions';
import { selectAnalyticsFilters } from '../../../store/analyticFiltersSlice';

export const MessagesMultiLineChart = () => {
    const filters = useAppSelector(selectAnalyticsFilters);

    const [
        getMessages,
        {
            isFetching,
            isLoading,
            data: messages = {
                total_messages: 0,
                messages_tonality: '',
                message_statistic: [],
                message_members_statistic: [],
                user_messages_chart: {
                    marks: [],
                },
            },
        },
    ] = useLazyGetMessagesQuery();

    useEffect(() => {
        if (filters) {
            const payload = {
                ...filters,
                community_id: +filters.chat || null,
                telegram_users_id: filters.telegram_accounts.length
                    ? filters.telegram_accounts
                    : null,
            };
            getMessages(payload, true);
        }
    }, [filters]);

    const chartData = filters.telegram_accounts.length
        ? buildWeeklySeries(messages)
        : {
              series: [
                  {
                      name: '',
                      type: 'line',
                      messages:
                          messages.message_statistic?.map(s => ({
                              y: s.messages,
                              x: dayjs(s.scale).format('DD.MM'),
                          })) || [],
                  },
              ],
          };

    return (
        <ChartWrapper isLoading={isFetching || isLoading} title='Сообщения'>
            <Chart
                height={'200px'}
                type='line'
                options={getOptions(chartData)}
                series={chartData?.series?.map(user => ({
                    type: 'line',
                    name: user.name,
                    data: user.messages,
                }))}
            />
        </ChartWrapper>
    );
};
